// extracted by mini-css-extract-plugin
export default {"container":"OurTeam_container__NoJV0","membercontainer":"OurTeam_membercontainer__dnzRL","member":"OurTeam_member__ZN0oN","image":"OurTeam_image__Mgoym"};